/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';

function SEO({ description, sharingImage, lang, meta, title, pathname }) {
  const { globalSeoSettings, site } = useStaticQuery(
    graphql`
      query {
        globalSeoSettings: storyblokEntry(
          field_component: { eq: "globalSeoSettings" }
        ) {
          content
        }
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  );

  // Build canonical URL with trailing slash
  const siteUrl = site.siteMetadata.siteUrl;
  let canonicalPath = pathname || '/';
  // Ensure path starts with /
  if (!canonicalPath.startsWith('/')) {
    canonicalPath = `/${canonicalPath}`;
  }
  // Ensure path ends with /
  if (!canonicalPath.endsWith('/')) {
    canonicalPath = `${canonicalPath}/`;
  }
  // Remove any double slashes (except after protocol)
  canonicalPath = canonicalPath.replace(/\/+/g, '/').toLowerCase();
  const canonicalUrl = `${siteUrl}${canonicalPath}`;

  const globalSeoSettingsParsed =
    globalSeoSettings && JSON.parse(globalSeoSettings.content);

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang
        }}
        title={title}
        titleTemplate={`%s${
          globalSeoSettingsParsed
            ? globalSeoSettingsParsed.titleSuffix
            : ' | Sertus'
        }`}
        link={[
          {
            rel: 'canonical',
            href: canonicalUrl
          }
        ]}
        meta={[
          {
            name: `description`,
            content: description
          },
          {
            property: `og:title`,
            content: title
          },
          {
            property: `og:description`,
            content: description
          },
          {
            property: `og:type`,
            content: `website`
          },
          {
            name: `og:image`,
            content:
              sharingImage ||
              (globalSeoSettingsParsed &&
                globalSeoSettingsParsed.sharingImage &&
                globalSeoSettingsParsed.sharingImage.filename) ||
              ''
          },
          {
            name: `twitter:card`,
            content: `summary`
          },
          {
            name: `twitter:title`,
            content: ''
          },
          {
            name: `twitter:description`,
            content: ''
          }
        ].concat(meta)}
      />
    </>
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  pathname: ''
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  pathname: PropTypes.string
};

export default SEO;
